import { Button } from '@efexteam/components';
import { useTranslation } from 'react-i18next';
import { INPUT_TYPES } from '@constants/inputs.constants';
import { AuthLayout } from '../../../components/auth/AuthLayout';
import { AuthFormContainer } from '../../../components/auth/AuthFormContainer';
import { PasswordInput } from '../../../components/password';
import { PASSWORD_SCHEMA } from '../../../schemas/auth.schemas';
import useLegacyPasswordReset from '../hooks/useLegacyPasswordReset';

const LegacyPasswordForm = () => {
  const { t } = useTranslation();

  const {
    handleSubmit,
    control,
    setValue,
    formState,
    success,
    error,
    isLoading,
    handleBackToLogin,
    onSubmit,
    getFieldError,
  } = useLegacyPasswordReset();

  const headerActions = (
    <Button
      appearance="secondary"
      variant="outlined"
      color="primary"
      onClick={handleBackToLogin}
    >
      {t('backToLogin')}
    </Button>
  );

  return (
    <AuthLayout headerActions={headerActions}>
      <AuthFormContainer
        title={t('resetPasswordTitle') as string}
        description={t('resetPasswordDescriptionLegacy') as string}
        onSubmit={handleSubmit(onSubmit)}
        submitButtonText={t('resetPasswordSubmitButton') as string}
        submitButtonDisabled={!formState.isValid}
        isLoading={isLoading}
        loadingText={t('resetPasswordSubmittingButton') as string}
        successMessage={
          success ? (t('resetPasswordSuccessMessage') as string) : undefined
        }
        errorMessage={error}
      >
        <PasswordInput
          control={control}
          setValue={setValue}
          name={INPUT_TYPES.PASSWORD}
          confirmFieldName={INPUT_TYPES.CONFIRM_PASSWORD}
          label={t('resetPasswordPasswordLabel') as string}
          confirmLabel={t('resetPasswordConfirmPasswordLabel') as string}
          error={!!formState.errors?.password}
          errorMessage={getFieldError(INPUT_TYPES.PASSWORD)}
          confirmError={!!formState.errors?.confirmPassword}
          confirmErrorMessage={getFieldError(INPUT_TYPES.CONFIRM_PASSWORD)}
          validationSchema={PASSWORD_SCHEMA}
          enforceValidation
        />
      </AuthFormContainer>
    </AuthLayout>
  );
};

export default LegacyPasswordForm;
